import { Col, Row, Text } from 'components';
import { Api, validateEmail } from 'lib';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';

const StyledInput = styled.input`
  color: #fff;
  width: 358px;
  font-family: CeraPro;
  font-size: 24px;
  line-height: 30px;
  color: #fff;
  margin-left: 5px;

  ${(props) =>
    props.isMobile &&
    `
    width: 258px;
    font-size: 16px;
    line-height: 22px;
  `}

  ::placeholder {
    color: #fff;
    opacity: 1;
  }
`;

const NewsLetter = ({ isMobile }) => {
  const [email, setEmail] = useState(''),
    { t } = useTranslation(),
    ref = useRef(),
    dispatch = useDispatch();

  async function handleSend() {
    if (!validateEmail(email)) {
      return dispatch({
        type: 'HANDLE_RES',
        payload: {
          err: t('website.invalidEmail')
        }
      });
    }

    const res = await Api.post('/website/joinNewsletter', { email });
    if (!res) return;

    setEmail('');
    dispatch({
      type: 'HANDLE_RES',
      payload: {
        res: t('website.addedToNewsletter')
      }
    });
  }

  return (
    <Col noFlex marg={isMobile ? '33px 0 0' : '0'}>
      <Row start>
        <Text col="#fff" size={isMobile ? '16px' : '24px'} lineHt={isMobile ? '22px' : '30px'}>
          {t('website.newsletter')}:
        </Text>

        <StyledInput
          isMobile={isMobile}
          placeholder={t('website.typeEmail')}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleSend();
            }
          }}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </Row>

      <Row marg="4px 0 0" wid={isMobile ? '308px' : '463px'} ht="1px" bg="#fff" />
    </Col>
  );
};

export default NewsLetter;
